module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.transfer.view.details'),
      "name": "first"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.transfer.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.code')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentTransfer.code) + " - " + _vm._s(_vm.currentTransfer.name) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.fromWarehouse')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'warehouse.edit',
        params: {
          id: _vm.currentTransfer.fromWarehouseId
        }
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.currentTransfer.fromWarehouse.name) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.toWarehouse')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'warehouse.edit',
        params: {
          id: _vm.currentTransfer.toWarehouseId
        }
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.currentTransfer.toWarehouse.name) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.comments')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentTransfer.comments) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.createdAt')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentTransfer.createdAt) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.status')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.currentTransfer.status) + "\n                  ")])]), _vm._v(" "), (_vm.currentTransfer.transferType === 6) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('button', {
    staticClass: "btn info el-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showPrintableDeliveryNote
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))])]) : _vm._e()]], 2)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.transfer.view.products'),
      "name": "products"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.transfer.view.productsLegend')))]), _vm._v(" "), _c('el-table', {
    staticClass: "transfer-product-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.productList,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('static.transfer.products.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.transfer.products.batch')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.batch) ? _c('router-link', {
          attrs: {
            "to": {
              name: 'production.batches.view',
              params: {
                id: scope.row.batch.id
              }
            },
            "target": "_blank"
          }
        }, [_vm._v("\n                      " + _vm._s(scope.row.batch.code) + "\n                    ")]) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": _vm.$t('static.transfer.products.qty')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "notes",
      "label": _vm.$t('static.transfer.products.notes')
    }
  })], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5ac6e60","hasScoped":false}!./src/app/pages/withNavigation/transfer/view/view.html
// module id = 3138
// module chunks = 1